export default __webpack_public_path__ + "media/zurb/img/events/wired/pie-ranch/pr-2-fd990ef853593f409ba9f804aab0e68c.jpg";